import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Twitter, Facebook, Instagram, Youtube } from "lucide-react";
import { Brand } from "./SiteHeader";
import { FIRM, SERVICES, NAV } from "./siteData";

export default function SiteFooter() {
  return (
    <footer className="bg-[#0C1726] text-white/70 border-t border-[#C4A66A]/20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Brand />
          <p className="mt-6 text-sm leading-relaxed max-w-sm">
            A new-age Chartered Accountancy firm founded in {FIRM.founded}, bringing three decades of Big Four experience to audit, tax, transactions, accounting and strategic finance.
          </p>
          <a href={FIRM.linkedin} target="_blank" rel="noopener noreferrer" aria-label="VCAJ on LinkedIn" className="mt-6 inline-flex items-center gap-3 h-10 px-4 border border-white/15 hover:border-[#C4A66A] hover:text-[#C4A66A] text-sm transition-colors" data-testid="footer-linkedin">
            <Linkedin className="h-4 w-4" /> Follow on LinkedIn
          </a>
          <div className="mt-4 flex gap-3">
            {[["twitter", Twitter], ["facebook", Facebook], ["instagram", Instagram], ["youtube", Youtube]].filter(([k]) => FIRM[k]).map(([k, Icon]) => (
              <a key={k} href={FIRM[k]} target="_blank" rel="noopener noreferrer" aria-label={k} className="h-10 w-10 inline-flex items-center justify-center border border-white/15 hover:border-[#C4A66A] hover:text-[#C4A66A] transition-colors" data-testid={`footer-${k}`}><Icon className="h-4 w-4" /></a>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="site-eyebrow">Verticals</div>
          <ul className="mt-5 space-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}><Link to={`/expertise/${s.slug}`} className="site-link hover:text-white" data-testid={`footer-service-${s.slug}`}>{s.title}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="site-eyebrow">Firm</div>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="site-link hover:text-white" data-testid={`footer-${n.id}`}>{n.label}</Link></li>
            ))}
            <li><Link to="/portal" className="site-link hover:text-white" data-testid="footer-employee-login">Employee Login</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="site-eyebrow">Office</div>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-[#C4A66A] shrink-0" /><span>{FIRM.address.join(" ")}</span></li>
            <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 text-[#C4A66A]" /><a href={FIRM.phoneHref} className="site-link hover:text-white" data-testid="footer-phone">{FIRM.phone}</a></li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 text-[#C4A66A]" /><a href={`mailto:${FIRM.email}`} className="site-link hover:text-white" data-testid="footer-email">{FIRM.email}</a></li>
            <li className="flex gap-3"><Linkedin className="h-4 w-4 mt-0.5 text-[#C4A66A]" /><a href={FIRM.linkedin} target="_blank" rel="noopener noreferrer" className="site-link hover:text-white" data-testid="footer-linkedin-link">VCAJ &amp; Associates LLP on LinkedIn</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs leading-relaxed text-white/45 flex flex-col md:flex-row gap-4 justify-between">
          <p className="max-w-3xl" data-testid="footer-icai-notice">
            This website is for information only and does not constitute solicitation or advertisement, in line with the guidelines of the Institute of Chartered Accountants of India (ICAI). Content is not professional advice; please consult us before acting on it.
          </p>
          <p className="shrink-0">© {new Date().getFullYear()} {FIRM.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
